import * as actions from './arquivamento.action';
import inicialState from './arquivamento.state';

const arquivamentoCommonReducer = (state = inicialState, action) => {
  switch (action.type) {

    case actions.ARQUIVAMENTO_COMMON_ATUALIZA_TAB:
      return {
        ...state,
        tab: action.payload.tab,
      };

      case actions.ARQUIVAMENTO_COMMON_ATUALIZAR_DATAINI:
        return {
          ...state,
          dataInicio: action.payload.dataInicio,
        };

      case actions.ARQUIVAMENTO_COMMON_ATUALIZAR_DATAFIM:
        return {
          ...state,
          dataFim: action.payload.dataFim,
        };
   
      case actions.ARQUIVAMENTO_COMMON_ATUALIZAR_FILTRO_VALUE:
        return {
          ...state,
          filtroValue: action.payload.filtroValue,
        };

    case actions.ARQUIVAMENTO_COMMON_ATUALIZA_IMPRIMIR:
      return {
        ...state,
        imprimir: action.payload.imprimir,
      };

    default:
      return state;
  }
};

export default arquivamentoCommonReducer;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/common/store/arquivamento.reducer.js